import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '~/shadcn/ui/table'
import { cn } from '~/shadcn/lib/utils'
import { Button } from '~/shadcn/ui/button/button'
import { Spinner } from '~/shadcn/ui/spinner'
import type { ExportMonth } from './export.utils'

type Props = {
  months: Array<ExportMonth>
  downloadingKey: string | null
  onDownload: (month: ExportMonth) => void
}

export function ExportTable({ months, downloadingKey, onDownload }: Props) {
  return (
    <div className="overflow-hidden">
      <Table>
        <TableHeader className="h-[34px]">
          <TableRow className="">
            <TableHead className="p-2 text-xs font-medium text-muted-foreground">
              DÁTUM
            </TableHead>

            <TableHead className="p-2 text-end text-xs font-medium text-muted-foreground">
              AKCIA
            </TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {months.map((month) => {
            const key = `${month.year}-${month.month}`
            const isDownloading = downloadingKey === key
            return (
              <TableRow
                key={key}
                className={cn(
                  'h-[34px]',
                  'text-sm font-medium',
                  '[&_td]:border-b [&_td]:border-muted-light',
                  'last:[&_td]:border-b-0'
                )}>
                <TableCell className="px-2">
                  <span>{month.label}</span>
                </TableCell>
                <TableCell className="px-2 py-0 text-end">
                  <Button
                    variant="ghost"
                    disabled={downloadingKey !== null}
                    onClick={() => onDownload(month)}
                    className={cn('h-[34px] gap-1 px-0')}>
                    {isDownloading && <Spinner className="size-4" />}
                    <span className="text-xs font-medium text-primary underline underline-offset-2">
                      Stiahnuť
                    </span>
                  </Button>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>
  )
}
